/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectGoalObjectiveFactorProgress } from './projectGoalObjectiveFactorProgress';
import { Report } from './report';
import { ProgramGoalObjectiveFactorProgressReportAllOf } from './programGoalObjectiveFactorProgressReportAllOf';


/**
 * Program goal / objective factor progress report
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProgramGoalObjectiveFactorProgressReport { 
    /**
     * Datetime that report data was materialized
     */
    readonly asOfDate?: string;
    /**
     * Goal / objective factor progress for Projects
     */
    readonly projectGoalObjectiveFactorProgress: Array<ProjectGoalObjectiveFactorProgress>;

    constructor(item?: Partial<ProgramGoalObjectiveFactorProgressReport>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            asOfDate: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.asOfDate : itemOrValue;

                    if (itemOrValue?.asOfDate != null) {
                        if (itemOrValue.asOfDate === '') {
                            itemOrValue.asOfDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.asOfDate = parseInt(itemOrValue.asOfDate.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.asOfDate = parseFloat(itemOrValue.asOfDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            projectGoalObjectiveFactorProgress: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectGoalObjectiveFactorProgress : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramGoalObjectiveFactorProgressReport.isValid,
        };
    }

    static isValid(obj: ProgramGoalObjectiveFactorProgressReport): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramGoalObjectiveFactorProgressReport.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.asOfDate.isValid(item);
            result = result && validationObject.projectGoalObjectiveFactorProgress.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

